<template>
  <div id="score" >
    <div style="text-align: center;margin-top: 15px;" v-if="!weekList.length && !stageList.length" >
      暂无数据
    </div>
    <van-tabs v-model="active" v-if="weekList.length" :ellipsis="false" @click="tabWeek" >
      <van-tab v-for="item in weekList" :title="item.name" :key="item.id"  >
        <div class="main" >
          <!--<div @click="stageBoolean=true" class="title" v-if="stages.id" >{{ stages.remark }} {{ stages.name }}</div>-->
          <div class="stages" v-if="stages.id" @click="stageBoolean=true" >
            <van-icon size="12px" name="arrow-down" />
            <span>{{ stages.name }}{{ stages.remark }}</span>
          </div>
          <div v-if="gameList.length" v-for="game in gameList" class="block" >
            <div class="time" >
              <span>{{ formatterDate(game.beginDate) }}</span>
              <span>第{{ game.seq }}场</span>
            </div>
            <van-row class="vs" >
              <van-col span="10" >{{ game.homeTeamName }}</van-col>
              <van-col span="4" >{{ game.homeRegularScore < 0 ?'-': game.homeRegularScore+game.homeShootoutScore }} - {{ game.awayRegularScore < 0 ? '-' : game.awayRegularScore+game.awayShootoutScore }} </van-col>
              <van-col span="10" >{{ game.awayTeamName}}</van-col>
            </van-row>
            <div class="name" >
              {{ game.venue }}
            </div>
          </div>
          <div class="rank" v-if="(stages.name!=='季后赛' || stages.stageType>0) && stages.knockoutType!=1 && teamRank && teamRank.length>0" >
             <div class="title" >积分榜</div>
            <van-row class="rank-title" type="flex" align="center" >
              <van-col span="8" >球队</van-col>
              <van-col span="2" >场次</van-col>
              <van-col span="1" >胜</van-col>
              <van-col span="3" >任胜/负</van-col>
              <van-col span="3" >进/失</van-col>
              <van-col span="2" >受罚</van-col>
              <van-col span="3" >净胜球</van-col>
              <van-col span="2" >积分</van-col>
            </van-row>
              <van-row v-for="(team, index) in teamRank" :key="index" type="flex" align="center" >
                <van-col span="8" >{{ team.rank }}. {{ team.teamName }}</van-col>
                <van-col span="2" >{{ team.totalGameCount }}</van-col>
                <van-col span="1" >{{ team.winGameCount }}</van-col>
                <van-col span="3" >{{ team.winByShootoutGameCount }} / {{ team.loseByShootoutGameCount }}</van-col>
                <van-col span="3" >{{ team.goalCount }} / {{ team.concededCount }}</van-col>
                <van-col span="2" >{{ team.penaltyMinutes }}</van-col>
                <van-col span="3" >{{ team.goalCount-team.concededCount}}</van-col>
                <van-col span="2" >{{ team.score }}</van-col>
              </van-row>
          </div>

          <div v-if="topScorers && topScorers.length>0" class="topScorers" >
            <div class="title" >射手榜</div>
              <van-row class="topScorers-title" type="flex" align="center" >
                <van-col span="10" >球队</van-col>
                <van-col span="4" >运动员</van-col>
                <van-col span="2" >号码</van-col>
                <van-col span="3" >射中</van-col>
                <van-col span="3" >协助</van-col>
                <van-col span="3" >任意球</van-col>
                <van-col span="3" >总计</van-col>
              </van-row>
              <van-row v-for="(scorers, index) in topScorers" :key="index" type="flex" align="center" >
                <van-col span="10" >{{ scorers.teamName }}</van-col>
                <van-col span="4" >{{ scorers.playerName }}</van-col>
                <van-col span="2" >{{ scorers.jerseyNo }}</van-col>
                <van-col span="3" >{{ scorers.goalCount }}</van-col>
                <van-col span="3" >{{ scorers.assistCount }}</van-col>
                <van-col span="3" >{{ scorers.shootoutCount }}</van-col>
                <van-col span="3" >{{ scorers.total }}</van-col>
              </van-row>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 弹出框 -->

    <van-popup v-model="stageBoolean" position="bottom">
      <van-picker
        show-toolbar
        :columns="stageList"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"
      >
      </van-picker>
    </van-popup>

  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { Icon, Button, Tab, Tabs, Toast, Actionsheet, Cell, CellGroup } from 'vant'
import { getMatchGroupScoreRank } from '@/api/match'
Vue.use(Icon).use(Button).use(Tab).use(Tabs).use(Toast).use(Actionsheet).use(Cell).use(CellGroup)
export default {
  name: 'Review',
  data() {
    return {
      active: null,
      routerParams: null,
      weekId: null,
      weekList: [],
      stages: {},
      stageId: null,
      stageList: [],
      stageBoolean: false,
      gameList: [],
      teamRank: [],
      topScorers: []
    }
  },
  created() {
    this.routerParams = this.$route.query
    if (!this.routerParams.groupId) {
      Toast('参赛错误')
      return
    }
    this.getMatchGroupScoreRank()
  },
  mounted () {},
  methods: {
    getMatchGroupScoreRank() {
      let params = {
        groupId: this.routerParams.groupId,
        weekId: this.weekId,
        stageId: this.stageId
      }
      getMatchGroupScoreRank(params).then((resolve) => {
        let data = resolve.data
        this.gameList = data.games
        this.teamRank = data.teamRank
        this.stageList = data.stages
        this.topScorers = data.topScorers
        this.weekList = data.weeks.filter((item, index) => {
          if (item.id === data.currentWeekId) {
            this.active = index
          }
          return true
        })
        data.stages.filter((item) => {
          if (item.id === data.currentStageId) {
            this.stages = item
          }
        })
      })
    },
    formatterDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    tabWeek(index) {
      this.weekId = this.weekList[index].id
      this.stages = {}
      this.stageList = []
      this.stageId = ''
      this.getMatchGroupScoreRank()
    },
    onCancel() {
      this.stageBoolean = false
    },
    onConfirm(item) {
      this.stageId = item.id
      this.stageBoolean = false
      this.getMatchGroupScoreRank()
    }
  },
  computed: {}
}
</script>
<style lang="scss" >
  #score {
    max-width: 768px; /*px*/
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
  }

  #score .time {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px 0;
  }

  #score .time span {
    padding: 0 5px;
  }

  #score .vs {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 16px;
    padding: 5px 0;
  }

  #score .van-tabs__wrap--scrollable .van-tab {
    /*flex: 0 0 30% !important;*/
  }

  #score table
  {
    border-collapse:collapse;
  }

  #score table, td, th
  {
    border: 1px solid transparent;
    border-bottom: 1px solid #ccc;
  }

  #score table, td {
    text-align: center;
  }

  #score .warning {
    padding: 15px 10px;
    color: white;
    background-color: #ff976a;
    font-size: 16px;
  }

  #score {
    .van-tabs--line {
      padding-top: 60px;
    }
    .van-tabs {
      .van-hairline--top-bottom::after {
        border-width: 0;
      }
    }
    .van-tabs__wrap {
      height: 30px;
      background:rgba(255,255,255,1);
      color: #9B9B9B;
      font-size: 16px;
      padding: 15px 0;
      .van-tab {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .van-tab--active {
        color: #185494;
      }
      .van-tabs__line {
        background-color: #185494;
      }
    }
    .main {
      .stages {
        padding: 10px 15px 15px;
        display: flex;
        align-items: center;
        .van-icon {
          padding: 3px;
          background-color: #E2E2E2;
          border-radius: 50%;
          color: #979797;
        }
        span {
          color: #9B9B9B;
          font-size: 12px;
          padding-left: 5px;
        }
      }
      .block {
        .time {
          height: 40px;
          background-color: #F8F8F8;
          font-size:14px;
          font-weight:400;
          color:rgba(74,74,74,1);
          letter-spacing: 1px;
        }
        .vs {
          padding: 0;
          height: 60px;
          font-size:18px;
          font-weight:400;
          color:rgba(0,0,0,1);
          .van-col {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            text-align: center;
            font-size: 14px; /*no*/
          }
        }
        .name {
          color: #4A4A4A;
          font-size: 14px;
          text-align: center;
          padding-bottom: 15px;
        }
      }
      .title {
        padding: 15px 15px;
        /*background: #F8F8F8;*/
        background: -webkit-gradient(linear,0 0,0 100%,from(#FFFFFF),to(#F8F8F8));
        color: #185494;
        font-weight: 500;
        font-size: 16px; /*no*/
      }
      .rank, .topScorers {
        padding-bottom: 15px;
        .rank-title, .topScorers-title {
          height: 50px;
          padding: 0 10px;
          font-weight:400;
          .van-col {
            color: #000 !important;
          }
        }
        .van-row {
          min-height: 30px;
          padding: 5px 10px;
          .van-col {
            /*white-space: nowrap;*/
            text-overflow: ellipsis;
            word-break: break-all;
            text-align: center;
            font-size: 12px; /*no*/
            color: #818181;
          }
          .van-col:first-child {
            text-align: left;
            color: #000;
          }
          .van-col:last-child {
            color: #000;
          }
        }
        .van-row:nth-child(even) {
          background-color: #FAFAFA;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/score-list.vue